<template>
  <div id="contenedor-main-usuarios-contratistas">
    <v-card flat>
      <v-card-text>
        <!-- Loader -->
        <v-skeleton-loader
          v-if="$apollo.loading"
          type="table-heading, table-thead, table-tbody"
        ></v-skeleton-loader>
        <listado v-else :listadoUsuariosContratistas="getUsuariosContratistas"> </listado>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import USUARIOS from '@/graphql/querys/administracion/catalogos/usuarios/usuarios.gql';
import Listado from './listado/Main.vue';

export default {
  name: 'MainUsuariosContratistas',
  data() {
    return {};
  },
  apollo: {
    usuarios: {
      query: USUARIOS,
    },
  },
  components: {
    Listado,
  },
  computed: {
    getUsuariosContratistas() {
      if (!this.usuarios) return [];
      return this.usuarios
        .slice()
        .filter((usuario) => usuario.idContratista)
        .filter((usuario) => {
          if (!this.buscarTexto) return usuario;
          const expt = new RegExp(this.buscarTexto, 'gi');
          const nombre = this.$normalizacionTexto(usuario.contratista.nombreRazonSocial);
          const email = this.$normalizacionTexto(usuario.correoElectronico);
          return (
            expt.test(nombre)
          || expt.test(email)
          || expt.test(usuario.nombre)
          || expt.test(usuario.correoElectronico)
          );
        });
    },
  },
};
</script>

<style lang="scss"></style>
